import type { State } from '../../reducer.tsx';

export const getItemsOnPage = (state: State): number => state.ui.page.itemsOnPage;

export const isLoading = (state: State): boolean => state.ui.page.isLoading;

export const getStartAt = (state: State, page: number) => getItemsOnPage(state) * (page - 1);
export const getMaxResults = (state: State) => getItemsOnPage(state);
